export default "__VITE_ASSET__b2e1818f__"